<script>
import Visibility from '@advisor/mixins/Visibility';
import {PROP} from '@advisor/util/constants';

export default {
  name: 'AdvBaseControl',
  mixins: [Visibility],
  props: {
    // eslint-disable-next-line vue/no-unused-properties, no-undefined, vue/require-prop-types
    color: {...PROP.STRING_TYPE, default: undefined},
    // eslint-disable-next-line vue/no-unused-properties, vue/require-prop-types
    dark: {...PROP.BOOLEAN_TYPE, default: false},
    // eslint-disable-next-line vue/no-unused-properties, vue/require-prop-types
    disabled: {...PROP.BOOLEAN_TYPE, default: false},
    // eslint-disable-next-line vue/no-unused-properties, vue/require-prop-types
    light: {...PROP.BOOLEAN_TYPE, default: false},
    // eslint-disable-next-line vue/no-unused-properties, vue/require-prop-types
    loading: {...PROP.BOOLEAN_TYPE, default: false},
  },
};
</script>

<template>
  <div>
    base control, should not be instantiated
    <br />
    the actual component should have these in the tempalte eg
    <pre>
      :color="color"
      :dark="dark"
      .
      .
      .
    </pre>
  </div>
</template>
